
import React from "react";

import {
  ArrowUpRight,
  Globe,
} from "lucide-react";

const PROJECTS = [
  {
    title: "Smile Dental Clinic",

    category: "Dental Clinic",

    image:
      "https://images.unsplash.com/photo-1629909613654-28e377c37b09",

    description:
      "Modern appointment-focused clinic website with WhatsApp booking integration.",
  },

  {
    title: "PowerFit Gym",

    category: "Gym & Fitness",

    image:
      "https://images.unsplash.com/photo-1571902943202-507ec2618e8f",

    description:
      "High-energy fitness website designed to generate membership inquiries.",
  },

  {
    title: "Elite Diagnostic Lab",

    category: "Diagnostic Center",

    image:
      "https://images.unsplash.com/photo-1580281657527-47f249e8f4df",

    description:
      "Professional healthcare website focused on trust and online visibility.",
  },

  {
    title: "Urban Spice Restaurant",

    category: "Restaurant",

    image:
      "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4",

    description:
      "Premium restaurant landing page with menu showcase and table booking CTA.",
  },
];

export default function Portfolio() {
  return (
    <section
      id="portfolio"
      className="py-20 lg:py-28 bg-gradient-to-b from-white to-slate-50"
    >

      <div className="max-w-7xl mx-auto px-5 lg:px-8">

        {/* Heading */}
        <div className="max-w-3xl mx-auto text-center">

          <p className="text-xs uppercase tracking-[0.22em] font-bold text-[var(--gf-blue)]">
            Portfolio
          </p>

          <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.08]">
            Demo websites built for real businesses.
          </h2>

          <p className="mt-5 text-lg text-[var(--gf-text-2)] leading-relaxed">
            Explore premium website concepts designed to help
            businesses generate more calls, leads and customer trust.
          </p>
        </div>

        {/* Grid */}
        <div className="mt-16 grid md:grid-cols-2 gap-7">

          {PROJECTS.map((p, i) => (
            <div
              key={i}
              className="group relative overflow-hidden rounded-3xl border border-[var(--gf-border)] bg-white gf-shadow-soft hover:-translate-y-1 transition-all duration-300"
            >

              {/* Image */}
              <div className="relative h-[280px] overflow-hidden">

                <img
                  src={p.image}
                  alt={p.title}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />

                {/* Floating Badge */}
                <div className="absolute top-5 left-5 inline-flex items-center gap-2 bg-white/90 backdrop-blur-md px-3 py-1.5 rounded-full text-xs font-semibold text-[var(--gf-primary)]">

                  <Globe className="h-3.5 w-3.5 text-[var(--gf-blue)]" />

                  {p.category}
                </div>
              </div>

              {/* Content */}
              <div className="p-7">

                <h3 className="font-display text-2xl font-extrabold">
                  {p.title}
                </h3>

                <p className="mt-3 text-sm text-[var(--gf-text-2)] leading-relaxed">
                  {p.description}
                </p>

                {/* Button */}
                <button
                  className="mt-6 inline-flex items-center gap-2 text-[var(--gf-blue)] font-semibold hover:gap-3 transition-all"
                >
                  View Demo

                  <ArrowUpRight className="h-4 w-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
